import * as React from 'react';
import { cn } from '@/lib/utils';
import { Slot } from '@radix-ui/react-slot';

const EssayTips = React.forwardRef(({ className, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    className={cn(
      'c-essay-tips',
      // styles
      'fixed right-0 top-[40%] z-10 flex cursor-pointer appearance-none items-center gap-2 rounded-bl-lg rounded-tl-lg border border-solid border-neutral-lightest bg-white p-4 text-xs font-bold leading-none text-black shadow-[0px_4px_10px_3px_#5D6A8633]',
      className
    )}
    {...props}
  />
));
EssayTips.displayName = 'EssayTips';

const EssayTipsIcon = React.forwardRef(({ className, ...props }, ref) => (
  <Slot
    ref={ref}
    className={cn(
      'c-essay-tips-icon',
      // styles
      'flex h-8 w-8 items-center justify-center rounded-full bg-[#FDB462] p-1 text-white',
      className
    )}
    {...props}
  />
));
EssayTipsIcon.displayName = 'EssayTipsIcon';

export { EssayTips, EssayTipsIcon };
